import * as React from 'react';

import {AutoPayPageContainer} from './containers';

interface Props {
}

export const AutoPayPage: React.FC<Props> = () => {
    return (
        <AutoPayPageContainer/>
    );
};
